module.exports = __webpack_public_path__ + "img/firstName.4401bddb.svg";